// src/ExtraDataSource.js - mock implementation
export default {
  isAvailable: () => false,
};
